import { Grid2 as Grid, Stack } from "@mui/material";
import { StyledStack } from "../../pages/ContractDetailsPage";
import { ContractBlocksTable } from "../components/ContractBlocksTable";
import { ContractDataSources, ContractSelectors } from "../components/ContractSelectors";
import { ContractServiceChargeRates } from "../components/ContractServiceChargeRates";
import { ContractSummaryCard } from "../components/ContractSummaryCard";
import { useContractLinks } from "../hooks/useContractLinks";
import { ContractTerms } from "./ContractTerms";

export const AdminContractDetails = () => {
  const { contract, isPending } = useContractLinks();

  if (!contract) {
    return null;
  }

  const blocks = contract.blocks?.length ? (
    <ContractBlocksTable contract={contract} isLoading={isPending} />
  ) : null;

  return (
    <StyledStack>
      <Grid container spacing={3} sx={{ pb: 4 }}>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 7, xl: 4 }}>
          <Stack gap={3}>
            <ContractSummaryCard contract={contract} isLoading={isPending} open />
            <ContractServiceChargeRates contract={contract} />
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 6, lg: 5, xl: 4 }}>
          <ContractDataSources contract={contract} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 6, lg: 12, xl: 4 }}>
          <ContractSelectors contract={contract} />
        </Grid>

        {blocks ? <Grid size={{ xs: 12 }}>{blocks}</Grid> : null}

        <Grid size={{ xs: 12 }}>
          <ContractTerms />
        </Grid>
      </Grid>
    </StyledStack>
  );
};
